import React, { useMemo, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { msalConfigErrors } from '../authConfig';

export default function LoginPage() {
  const { instance } = useMsal();
  const [runtimeError, setRuntimeError] = useState<string | null>(() => sessionStorage.getItem('MSAL_LAST_ERROR'));
  const configError = useMemo(() => {
    if (msalConfigErrors.length > 0) {
      return msalConfigErrors.join(' ');
    }
    return null;
  }, []);

  function handleLogin() {
    if (configError) {
      setRuntimeError(configError);
      return;
    }

    sessionStorage.removeItem('MSAL_LAST_ERROR');
    setRuntimeError(null);

    instance.loginRedirect({ scopes: ['openid', 'profile', 'User.Read'] }).catch((err: unknown) => {
      const message = err instanceof Error ? err.message : 'Sign-in failed to start.';
      sessionStorage.setItem('MSAL_LAST_ERROR', message);
      setRuntimeError(message);
    });
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-10 w-full max-w-sm text-center space-y-6">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">Saward Dawson</h1>
          <p className="text-sm text-gray-500 mt-1">AI Apps</p>
        </div>

        <button
          onClick={handleLogin}
          className="w-full flex items-center justify-center gap-3 px-4 py-2.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
        >
          <svg width="20" height="20" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
            <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
          </svg>
          Sign in with Microsoft
        </button>

        {(configError || runtimeError) && (
          <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-left">
            <p className="text-xs font-semibold text-red-800">Sign-in error</p>
            <p className="mt-1 text-xs text-red-700 break-words">{runtimeError || configError}</p>
          </div>
        )}

        <p className="text-xs text-gray-400">
          Access is restricted to Saward Dawson staff.
        </p>
      </div>
    </div>
  );
}
